import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaCheck from 'react-icons/lib/fa/check';
import FaClose from 'react-icons/lib/fa/close';

import styles from './ValidityIcon.scss';

function ValidityIcon(props) {
    const {
        isValid,
        className,
        onClick,
        'data-id': dataId,
        ...otherProps
    } = props;

    function _onClick(e) {
        if (!isValid) {
            return onClick(e);
        }
    }

    let Icon = FaClose;
    let validityClass = styles.invalidIndicator;
    if (isValid) {
        Icon = FaCheck;
        validityClass = styles.validIndicator;
    }

    return (
        <span
            className={classNames(className, validityClass)}
            data-id={dataId}
        >
            <Icon {...otherProps} onClick={_onClick} />
        </span>
    );
}

ValidityIcon.propTypes = {
    className: PropTypes.string,
    'data-id': PropTypes.string,
    isValid: PropTypes.bool,
    onClick: PropTypes.func,
};

ValidityIcon.defaultProps = {
    className: '',
    'data-id': '',
    isValid: false,
    onClick() {},
};

export default ValidityIcon;
